export default __webpack_public_path__ + "static/media/device-frame-desktop-1.4a60ff2c.png";